// Modules
import React from "react";

const PlantIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<g>
					<path d="M447.602,252.313c16.43-56.466,11.209-108.178,10.979-110.352c-0.002-0.016-0.006-0.032-0.008-0.048
			c-0.031-0.278-0.075-0.554-0.137-0.825c-0.005-0.021-0.012-0.041-0.017-0.062c-0.057-0.243-0.128-0.482-0.209-0.717
			c-0.028-0.082-0.061-0.161-0.092-0.241c-0.068-0.176-0.14-0.349-0.221-0.52c-0.039-0.083-0.079-0.164-0.121-0.245
			c-0.089-0.172-0.185-0.339-0.287-0.504c-0.041-0.066-0.08-0.133-0.123-0.198c-0.135-0.204-0.281-0.402-0.437-0.593
			c-0.016-0.019-0.029-0.04-0.045-0.059c-0.181-0.217-0.374-0.424-0.581-0.621c-0.024-0.023-0.051-0.043-0.075-0.066
			c-0.174-0.162-0.356-0.316-0.548-0.463c-0.069-0.053-0.142-0.102-0.214-0.153c-0.152-0.108-0.308-0.212-0.47-0.31
			c-0.043-0.026-0.082-0.057-0.125-0.083c-0.05-0.029-0.103-0.049-0.154-0.077c-0.07-0.038-0.134-0.081-0.206-0.117
			c-0.087-0.044-0.177-0.077-0.265-0.118c-0.096-0.044-0.192-0.089-0.289-0.129c-0.183-0.075-0.368-0.139-0.554-0.199
			c-0.073-0.023-0.144-0.05-0.217-0.071c-0.541-0.156-1.09-0.247-1.638-0.278c-0.053-0.003-0.105-0.001-0.158-0.003
			c-0.218-0.008-0.436-0.007-0.653,0.004c-0.084,0.004-0.168,0.012-0.251,0.019c-0.189,0.016-0.376,0.039-0.562,0.07
			c-0.091,0.015-0.182,0.03-0.272,0.048c-0.192,0.039-0.381,0.087-0.569,0.14c-0.076,0.021-0.152,0.039-0.227,0.063
			c-0.26,0.082-0.515,0.177-0.764,0.287c-0.006,0.003-0.013,0.005-0.02,0.007c-0.738,0.329-11.215,5.056-34.484,18.36
			c14.217-57.433-0.248-100.031-2.115-105.135c-0.021-0.058-0.049-0.111-0.071-0.168c-0.045-0.116-0.094-0.229-0.145-0.343
			c-0.051-0.113-0.104-0.225-0.16-0.334c-0.053-0.104-0.11-0.206-0.168-0.308c-0.064-0.112-0.129-0.221-0.198-0.329
			c-0.061-0.095-0.125-0.188-0.191-0.28c-0.075-0.105-0.151-0.209-0.23-0.31c-0.071-0.089-0.144-0.176-0.219-0.263
			c-0.083-0.096-0.168-0.19-0.255-0.281c-0.08-0.083-0.163-0.164-0.247-0.244c-0.093-0.088-0.186-0.173-0.283-0.255
			c-0.087-0.074-0.175-0.146-0.266-0.217c-0.105-0.082-0.212-0.16-0.32-0.235c-0.089-0.062-0.179-0.124-0.272-0.182
			c-0.121-0.076-0.244-0.148-0.368-0.217c-0.058-0.033-0.112-0.07-0.172-0.101c-0.033-0.018-0.068-0.03-0.102-0.047
			c-0.127-0.064-0.256-0.121-0.386-0.178c-0.099-0.043-0.198-0.088-0.298-0.127c-0.119-0.046-0.241-0.085-0.363-0.125
			c-0.112-0.037-0.223-0.076-0.336-0.107c-0.115-0.032-0.232-0.056-0.349-0.082c-0.119-0.027-0.237-0.057-0.357-0.078
			c-0.122-0.021-0.246-0.033-0.369-0.049c-0.114-0.014-0.228-0.032-0.342-0.041c-0.14-0.011-0.281-0.011-0.421-0.014
			c-0.098-0.002-0.196-0.009-0.294-0.007c-0.148,0.003-0.296,0.017-0.445,0.028c-0.092,0.007-0.185,0.01-0.276,0.021
			c-0.135,0.016-0.27,0.042-0.405,0.065c-0.106,0.018-0.213,0.033-0.319,0.055c-0.113,0.025-0.225,0.058-0.338,0.088
			c-0.127,0.034-0.255,0.066-0.38,0.106c-0.021,0.007-0.042,0.01-0.063,0.017c-4.694,1.558-43.985,15.567-79.111,58.072
			c-22.941-61.267-56.384-95.352-61.73-100.538c-0.06-0.058-0.125-0.108-0.187-0.164c-0.107-0.097-0.213-0.195-0.326-0.286
			c-0.089-0.072-0.182-0.138-0.274-0.205c-0.103-0.076-0.204-0.152-0.31-0.223c-0.102-0.068-0.207-0.128-0.312-0.19
			c-0.104-0.061-0.206-0.124-0.313-0.181c-0.107-0.057-0.217-0.106-0.327-0.157c-0.11-0.052-0.22-0.105-0.333-0.151
			c-0.109-0.044-0.219-0.081-0.33-0.121c-0.119-0.042-0.236-0.086-0.357-0.122c-0.111-0.033-0.224-0.059-0.337-0.087
			c-0.122-0.03-0.243-0.064-0.367-0.088c-0.128-0.025-0.257-0.04-0.385-0.059c-0.111-0.016-0.221-0.036-0.334-0.047
			c-0.22-0.021-0.442-0.031-0.663-0.033C256.045,0.003,256.023,0,255.999,0c-0.023,0-0.045,0.003-0.068,0.003
			c-0.221,0.002-0.442,0.012-0.663,0.033c-0.113,0.011-0.223,0.031-0.334,0.047c-0.129,0.018-0.258,0.034-0.385,0.059
			c-0.125,0.024-0.245,0.057-0.367,0.088c-0.113,0.028-0.226,0.053-0.337,0.087c-0.121,0.036-0.238,0.08-0.357,0.122
			c-0.111,0.039-0.221,0.076-0.33,0.121c-0.113,0.046-0.222,0.099-0.332,0.151c-0.11,0.051-0.219,0.101-0.327,0.158
			c-0.107,0.056-0.209,0.119-0.313,0.181c-0.105,0.062-0.21,0.122-0.312,0.19c-0.107,0.07-0.208,0.147-0.31,0.223
			c-0.092,0.068-0.185,0.133-0.274,0.205c-0.113,0.091-0.219,0.189-0.326,0.286c-0.062,0.056-0.127,0.106-0.187,0.164
			c-5.346,5.187-38.789,39.271-61.73,100.538c-35.126-42.505-74.417-56.514-79.111-58.072c-0.022-0.007-0.044-0.011-0.065-0.018
			c-0.117-0.038-0.237-0.067-0.356-0.099c-0.121-0.033-0.242-0.068-0.363-0.095c-0.092-0.02-0.184-0.032-0.277-0.048
			c-0.15-0.027-0.299-0.055-0.449-0.072c-0.07-0.008-0.141-0.01-0.212-0.016c-0.17-0.015-0.34-0.029-0.509-0.032
			c-0.076-0.001-0.152,0.004-0.228,0.005c-0.163,0.002-0.325,0.004-0.487,0.016c-0.098,0.008-0.195,0.024-0.293,0.035
			c-0.139,0.016-0.279,0.031-0.417,0.055c-0.111,0.019-0.221,0.048-0.332,0.072c-0.124,0.028-0.249,0.053-0.372,0.087
			c-0.11,0.031-0.219,0.069-0.329,0.105c-0.123,0.04-0.246,0.079-0.366,0.126c-0.103,0.04-0.204,0.086-0.305,0.13
			c-0.126,0.055-0.251,0.11-0.373,0.172c-0.036,0.018-0.073,0.031-0.108,0.05c-0.063,0.033-0.121,0.073-0.183,0.108
			c-0.118,0.066-0.235,0.134-0.349,0.206c-0.098,0.062-0.194,0.127-0.288,0.193c-0.103,0.072-0.204,0.146-0.304,0.223
			c-0.096,0.074-0.189,0.151-0.281,0.229c-0.091,0.078-0.18,0.159-0.268,0.242c-0.089,0.084-0.176,0.169-0.26,0.257
			c-0.084,0.087-0.164,0.177-0.244,0.268c-0.079,0.09-0.156,0.181-0.229,0.275c-0.076,0.097-0.15,0.197-0.222,0.298
			c-0.068,0.096-0.135,0.192-0.198,0.291c-0.067,0.105-0.131,0.212-0.193,0.32c-0.06,0.104-0.117,0.208-0.172,0.315
			c-0.055,0.108-0.107,0.218-0.158,0.329c-0.052,0.114-0.1,0.229-0.146,0.345c-0.022,0.057-0.05,0.11-0.071,0.168
			c-1.867,5.104-16.332,47.702-2.115,105.135c-23.27-13.304-33.747-18.031-34.484-18.36c-0.008-0.004-0.016-0.006-0.024-0.009
			c-0.246-0.109-0.498-0.202-0.755-0.284c-0.082-0.026-0.166-0.045-0.249-0.069c-0.18-0.051-0.362-0.097-0.546-0.134
			c-0.096-0.019-0.192-0.035-0.288-0.05c-0.18-0.029-0.361-0.051-0.543-0.067c-0.09-0.008-0.179-0.016-0.268-0.021
			c-0.208-0.011-0.417-0.011-0.626-0.004c-0.061,0.002-0.123,0-0.184,0.004c-0.544,0.031-1.089,0.122-1.626,0.276
			c-0.083,0.024-0.164,0.055-0.247,0.081c-0.175,0.057-0.349,0.117-0.521,0.187c-0.106,0.043-0.211,0.092-0.315,0.14
			c-0.083,0.038-0.167,0.069-0.249,0.111c-0.066,0.034-0.126,0.074-0.191,0.109c-0.055,0.03-0.113,0.052-0.167,0.084
			c-0.048,0.028-0.09,0.062-0.137,0.09c-0.151,0.092-0.297,0.189-0.44,0.29c-0.081,0.057-0.163,0.112-0.241,0.172
			c-0.176,0.135-0.343,0.278-0.504,0.426c-0.038,0.035-0.079,0.067-0.117,0.102c-0.202,0.193-0.392,0.396-0.569,0.609
			c-0.026,0.031-0.048,0.065-0.074,0.097c-0.145,0.179-0.281,0.363-0.408,0.554c-0.048,0.072-0.092,0.147-0.137,0.221
			c-0.097,0.157-0.188,0.315-0.273,0.478c-0.046,0.088-0.089,0.176-0.132,0.266c-0.076,0.162-0.145,0.327-0.209,0.494
			c-0.034,0.088-0.07,0.174-0.101,0.264c-0.076,0.22-0.14,0.444-0.195,0.67c-0.009,0.036-0.021,0.071-0.03,0.107
			c-0.061,0.268-0.104,0.541-0.136,0.815c-0.002,0.018-0.007,0.035-0.009,0.053c-0.23,2.174-5.451,53.886,10.979,110.352
			c8.322,28.601,26.315,52.733,50.743,68.818c-8.926,4.483-15.069,13.721-15.069,24.371c0,14.114,10.782,25.756,24.542,27.124
			l16.11,86.626C146.408,489.816,173.098,512,204.187,512h103.625c31.088,0,57.777-22.184,63.462-52.749l16.085-86.49h9.282
			c15.031,0,27.26-12.229,27.26-27.26c0-13.677-10.126-25.03-23.274-26.965C423.134,302.503,439.715,279.419,447.602,252.313z
			 M394.838,165.223c-12.296,7.337-26.945,16.339-44.159,27.302c-0.154,0.098-0.309,0.197-0.463,0.295
			c-2.036,1.297-4.104,2.62-6.212,3.972c-0.109,0.07-0.215,0.137-0.323,0.207c-0.046-0.574-0.1-1.146-0.149-1.719
			c-0.128-1.529-0.263-3.052-0.409-4.564c17.42-36.628,37.203-76.315,58.938-118.237C405.645,92.02,407.911,125.373,394.838,165.223
			z M387.732,67.525c-17.412,33.623-33.569,65.808-48.259,96.132c-2.761-15.845-6.442-30.567-10.714-44.143
			C349.303,92.145,372.045,76.178,387.732,67.525z M313.119,119.812c0.052,0.235,0.109,0.47,0.185,0.702
			c8.174,24.944,13.363,51.221,15.469,78.269c0.016,0.208,0.031,0.416,0.047,0.625c0.118,1.552,0.224,3.107,0.321,4.663
			c0.028,0.446,0.057,0.892,0.083,1.339c0.024,0.405,0.041,0.812,0.064,1.218c-24.237,17.653-44.115,41.568-59.434,71.445
			c-0.037,0.071-0.073,0.142-0.11,0.213c-0.583,1.141-1.161,2.29-1.731,3.449c-0.094,0.192-0.188,0.384-0.282,0.576
			c-0.543,1.11-1.082,2.226-1.613,3.352c-0.094,0.198-0.185,0.398-0.278,0.597c-0.793,1.694-1.573,3.405-2.339,5.135V27.122
			c7.416,9.179,17.086,22.603,26.809,40.294C299.505,84.147,307.111,101.64,313.119,119.812z M198.697,120.514
			c0.076-0.232,0.132-0.467,0.185-0.702c6.008-18.172,13.614-35.665,22.809-52.396c9.722-17.692,19.393-31.116,26.81-40.295v264.273
			c-0.767-1.732-1.548-3.447-2.343-5.143c-0.091-0.195-0.181-0.391-0.273-0.586c-0.532-1.128-1.072-2.246-1.617-3.359
			c-0.093-0.19-0.186-0.381-0.279-0.571c-0.571-1.159-1.148-2.309-1.732-3.451c-0.036-0.071-0.073-0.142-0.11-0.213
			c-15.319-29.877-35.197-53.791-59.434-71.445c0.023-0.406,0.04-0.813,0.064-1.218c0.026-0.447,0.055-0.892,0.083-1.339
			c0.098-1.557,0.203-3.112,0.321-4.663c0.016-0.208,0.031-0.417,0.047-0.625C185.333,171.734,190.523,145.458,198.697,120.514z
			 M183.239,119.514c-4.272,13.576-7.952,28.299-10.714,44.144c-14.687-30.319-30.844-62.504-48.259-96.133
			C139.955,76.178,162.697,92.145,183.239,119.514z M109.94,72.48c21.739,41.93,41.522,81.618,58.937,118.238
			c-0.146,1.511-0.281,3.034-0.409,4.563c-0.048,0.573-0.103,1.145-0.149,1.719c-0.108-0.069-0.213-0.136-0.321-0.205
			c-2.141-1.374-4.242-2.717-6.309-4.034c-0.104-0.066-0.208-0.133-0.311-0.198c-17.239-10.98-31.907-19.994-44.217-27.339
			C104.088,125.373,106.354,92.02,109.94,72.48z M130.353,190.803c0.715,0.442,1.435,0.888,2.155,1.334
			c1.617,1.002,3.262,2.024,4.937,3.069c1.238,0.773,2.482,1.55,3.734,2.336c0.967,0.607,1.938,1.216,2.924,1.836
			c1.769,1.114,3.552,2.24,5.347,3.378c0.639,0.405,1.275,0.808,1.922,1.218c2.13,1.353,4.277,2.722,6.442,4.108
			c0.511,0.327,1.03,0.66,1.545,0.991c2.346,1.505,4.705,3.021,7.09,4.562c0.854,0.552,1.698,1.118,2.541,1.685
			c0.553,0.374,1.12,0.762,1.717,1.176c0.008,0.006,0.017,0.012,0.025,0.017c0.001,0.001,0.002,0.001,0.002,0.002
			c30.127,20.893,53.328,52.201,69.133,93.226c0.098,0.256,0.193,0.516,0.291,0.772c0.451,1.182,0.899,2.368,1.339,3.566
			c0.199,0.545,0.393,1.098,0.59,1.646c0.301,0.836,0.602,1.671,0.897,2.515h-9.097c-50.396-23.041-92.656-69.901-119.324-105.335
			c-14.938-19.848-26.767-38.397-34.824-51.907C91.427,167.447,108.08,177.048,130.353,190.803z M78.801,248.122
			c-8.628-29.655-10.922-58.388-11.244-78.213c8.182,13.645,19.945,31.966,34.85,51.79c32.31,42.975,65.819,75.32,99.933,96.542
			h-60.876C110.83,305.34,88.035,279.858,78.801,248.122z M408.902,345.501c0,6.76-5.5,12.26-12.26,12.26H219.999
			c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h152.101l-15.575,83.748C352.163,479.971,331.676,497,307.813,497H204.187
			c-23.864,0-44.352-17.029-48.714-40.491l-15.575-83.748h26.434c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5h-38.966
			c-0.034-0.001,0,0-0.034,0c-6.76,0-12.26-5.5-12.26-12.26s5.5-12.26,12.26-12.26h269.309
			C403.402,333.241,408.902,338.741,408.902,345.501z M370.536,318.241h-60.895c31.927-19.88,63.395-49.556,93.848-88.574
			c2.549-3.266,1.968-7.979-1.298-10.527c-3.262-2.546-7.978-1.967-10.526,1.298c-36.89,47.264-75.007,80.136-113.296,97.704
			c-0.066,0.03-0.127,0.068-0.192,0.1h-9.16c0.295-0.844,0.596-1.679,0.897-2.515c0.197-0.548,0.39-1.101,0.59-1.646
			c0.439-1.198,0.887-2.384,1.339-3.566c0.098-0.256,0.193-0.517,0.291-0.772c15.805-41.025,39.006-72.333,69.133-93.226
			c0.001-0.001,0.002-0.001,0.002-0.002c0.008-0.006,0.017-0.012,0.025-0.017c0.597-0.414,1.163-0.801,1.716-1.175
			c0.843-0.568,1.688-1.134,2.542-1.686c2.379-1.537,4.731-3.049,7.071-4.549c0.528-0.338,1.058-0.679,1.581-1.014
			c2.152-1.377,4.285-2.738,6.402-4.083c0.675-0.429,1.34-0.85,2.006-1.272c1.736-1.1,3.46-2.189,5.172-3.267
			c1.051-0.661,2.086-1.312,3.116-1.957c1.201-0.753,2.393-1.499,3.581-2.24c1.807-1.127,3.579-2.229,5.319-3.306
			c0.592-0.367,1.184-0.734,1.772-1.097c22.322-13.788,39.006-23.406,50.71-29.862c-2.888,4.844-6.258,10.331-10.088,16.298
			c-2.237,3.486-1.226,8.125,2.261,10.363c1.254,0.805,2.656,1.189,4.044,1.189c2.469,0,4.886-1.218,6.318-3.45
			c3.624-5.646,6.842-10.861,9.64-15.525c-0.316,19.802-2.607,48.527-11.258,78.259C423.965,279.858,401.17,305.34,370.536,318.241z
			"/>
				</g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
		</svg>
	);
};

export default PlantIcon;
